import {
  getSession,
  listMyWorkspaces,
  redeemInvite,
} from '@bangle.io/supabase';
import React, { useEffect, useState } from 'react';
import {
  queuePendingCloudWorkspace,
  queuePendingOpenWorkspace,
} from '../share/sync-cloud-workspaces';

export function JoinPage({ code }: { code: string }) {
  const [status, setStatus] = useState(t.app.pageAuth.joinChecking);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        const session = await getSession();
        if (!session) {
          window.location.replace(
            `/login?next=${encodeURIComponent(`/join/${code}`)}`,
          );
          return;
        }
        setStatus(t.app.pageAuth.joinRedeeming);
        const result = await redeemInvite(code);
        const workspaces = await listMyWorkspaces();
        const ws = workspaces.find((w) => w.id === result.workspace_id);
        queuePendingCloudWorkspace({
          workspaceId: result.workspace_id,
          title: ws?.title ?? 'Shared notebook',
        });
        queuePendingOpenWorkspace(result.workspace_id);
        setStatus(t.app.pageAuth.joinOpening);
        window.location.replace('/');
      } catch (err) {
        setError(
          err instanceof Error ? err.message : t.app.pageAuth.joinFailed,
        );
      }
    })();
  }, [code]);

  return (
    <div className="sn-auth-shell">
      <div className="sn-auth-stage sn-auth-stage--compact">
        <section className="sn-auth-panel">
          <h1 className="sn-auth-brand sn-auth-brand--compact">
            {t.app.pageAuth.brand}
          </h1>
          {error ? (
            <p className="sn-auth-error" role="alert">
              {error}
            </p>
          ) : (
            <p className="sn-auth-sub sn-auth-sub--solo">{status}</p>
          )}
        </section>
      </div>
    </div>
  );
}
